import { Link } from "react-router-dom";
import Tags from "../tags/Tags";

export default function RelatedPostListItem({ post }) {
  const {id, title, image, tags, createdAt } = post || {};
  return (
    <div className="card">
      <Link to={`/posts/${id}`}>
        <img src={image} className="card-image" alt={title} />
      </Link>
      <div className="p-4">
        <Link to={`/posts/${id}`} className="text-lg post-title lws-RelatedPostTitle">
          {title}
        </Link>
        <div className="mb-0 tags">
            {tags.map((tag)=> <Tags tags={tag} key={tag} />)}         
        </div>
        <p>{createdAt}</p>
      </div>
    </div>
  );
}